import PlusApi from '@/api/plus';
import store from '@/store';

const getInitialParams = () => ({
  skip: 0,
  limit: 100,
  only_deleted: false,
  order: {
    column: 'created_at',
    desc: true,
  },
});

export default {
  namespaced: true,

  state: {
    data: [],
    meta: {},
    loading: false,
    error: null,
    params: getInitialParams(),
    currentItem: null,
  },

  actions: {
    async fetch(ctx) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        const params = ctx.getters.params;
        const response = await PlusApi.fetch({
          ...params,
          order: `${params.order.desc ? '-' : ''}${params.order.column}`,
        });

        if (!response.cancelled) {
          ctx.commit('setData', response.data.data.items);
          ctx.commit('setMeta', response.data.meta);
          ctx.commit('setLoading', false);
        }
      } catch (err) {
        ctx.commit('setError', err);
        ctx.commit('setLoading', false);
      }
    },

    async create(ctx, model) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);

      try {
        let items;
        try {
          items = model.sourceString.split('\n').reduce((acc, r, index) => {
            r = r.trim();
            if (!r) {
              return acc;
            }

            const [vin, code] = r.trim().split(';');
            if (!vin || !code) {
              throw `Невалидные данные, строка ${index + 1}`;
            }

            return [...acc, { vin, code }];
          }, []);
        } catch (err) {
          ctx.commit('setError', err);
          return err;
        }

        const { name, sub } = store.getters['user/profile'];
        const response = await PlusApi.bulkCreate({
          user_id: sub,
          user_name: name,
          items,
        });

        ctx.commit('setCurrentItem', {
          ...model,
          items: response.data.data,
        });
        return null;
      } catch (err) {
        ctx.commit('setError', err);
        return err;
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async changeParams(ctx, params, reset) {
      if (reset) {
        ctx.commit('changeParams', {
          ...getInitialParams(),
          ...params,
        });
      } else {
        ctx.commit('changeParams', params);
      }
    },

    clearCurrentItem(ctx) {
      ctx.commit('clearCurrentItem');
    },

    async export(ctx) {
      ctx.commit('setLoading', true);

      try {
        return await PlusApi.export();
      } catch (err) {
        return err;
      } finally {
        ctx.commit('setLoading', false);
      }
    },

    async delete(ctx, code) {
      ctx.commit('setLoading', true);
      ctx.commit('setError', null);
      try {
        await PlusApi.delete(code)
        return null
      } catch (err) {
        ctx.commit('setError', err);
        return err;
      } finally {
        ctx.commit('setLoading', false);
      }
    }
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },

    setError(state, err) {
      state.error = err;
    },

    setData(state, data) {
      state.data = data;
    },

    setMeta(state, meta) {
      state.meta = meta;
    },

    changeParams(state, params) {
      Object.assign(state.params, params);
    },

    setCurrentItem(state, data) {
      state.currentItem = data;
    },

    clearCurrentItem(state, data) {
      state.currentItem = null;
    },
  },

  getters: {
    meta: state => state.meta,
    list: state => state.data,
    error: state => state.error,
    params: (state, getters) => {
      return {
        search_string: getters.searchQuery,
        ...state.params,
        order_by: state.params.order.column,
        order_dir: state.params.order.desc ? 'desc' : 'asc',
      };
    },
    loading: state => state.loading,
    searchQuery: (state, getters, rootState, rootGetters) => rootGetters['util/searchQuery'],
    currentItem: state => state.currentItem,
  },
};
